import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import React from "react";
import PersonIcon from "../../../assets/header/user.png";
import useStyles from "./styles";
import { useAuth } from "../../../hooks/useAuth";

const ProfileMenu = ({ anchorEl, onClose, handleSignOut }) => {
  const classes = useStyles();
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const { token } = useAuth();

  React.useEffect(() => {
    const user = JSON.parse(localStorage.getItem("@datasales:user"));
    setName(user.name);
    setEmail(user.email);
  }, []);

  function handleOpenFinancial (event) {
    window.location.replace( `https://tech.datasales.info/sign-as-user/${token}?shortToRedirect=financial`)
  }
  return (
    <Menu
      id="profile-menu"
      className={classes.menu}
      classes={{ paper: classes.paper }}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      TransitionComponent={Fade}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
    >
      <Box paddingX={2} paddingY={1}>
        <Grid container direction="column" spacing={2}>
          <Grid
            item
            container
            direction="column"
            alignItems="center"
            xs={12}
            spacing={1}
          >
            <Grid item xs={12}>
              <Avatar alt={name} className={classes.avatar} src={PersonIcon} />
            </Grid>
            <Grid item xs={12}>
              <Typography align="center" variant="h6">
                {name}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography align="center" variant="body1">
                {email}
              </Typography>
            </Grid>
          </Grid>
          <Grid item>   
            <Divider />
          </Grid>
            <Grid item xs={12} >
                <Button
                  onClick={handleOpenFinancial}
                  fullWidth
                  variant="outlined"
                >
                  Financeiro
                </Button>
              </Grid>
          <Grid item container xs={12}>
            <Grid item xs={12} >
              <Button
                onClick={handleSignOut}
                fullWidth
                variant="outlined"
                className={classes.exit}
              >
                Sair
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Menu>
  );
};

export default ProfileMenu;
